import { call, select } from 'redux-saga/effects'

import { getCurrentBusinessId } from '../duck/businesses'

// eslint-disable-next-line func-names
export default function* (method, ...params) {
  const currentBusinessId = yield select(getCurrentBusinessId)
  return yield call(method, currentBusinessId, ...params)
}
